import AuthProvider from "config/authenticator";

async function PortalAuth() {
  let isloggedin = await AuthProvider();

  if (!isloggedin){
    window.location="/signin";
  }

  return isloggedin;
}

export default PortalAuth;
